import * as React from 'react';
import {Outlet,useNavigate} from 'react-router-dom';
import {AppBar,Box,IconButton,Toolbar,Typography} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import {Confirmation} from '../utils';
import {CONST,TokenValidator} from '../../utils';
import NavigationActions from '../navigationActions';

const ADMIN_ROLE=4;
export default function Holder(){
    const nav=useNavigate();
    const [logged,setLogged]=React.useState(false);
    const [logoutOpen,setLogoutOpen]=React.useState(false);
    React.useEffect(()=>{(async()=>{
        const token=await TokenValidator.GetInternalUser();
        if(!token||!(await TokenValidator.ValidTokenDate(token))){setLogged(false);nav('/shippinglabelmanagement',{replace:true});return;}
        const decoded=await TokenValidator.SimplifyToken(token);
        if((Number(decoded.roles)&ADMIN_ROLE)!==ADMIN_ROLE){setLogged(false);nav('/shippinglabelmanagement',{replace:true});return;}
        setLogged(true);
    })();},[nav]);
    const logout=()=>{localStorage.removeItem(CONST.STORAGE_KEYS.INTERNAL_LOGIN);setLogged(false);setLogoutOpen(false);nav('/shippinglabelmanagement',{replace:true});};
    return <Box sx={{minHeight:'100vh'}}>
        <AppBar position='static'><Toolbar><NavigationActions/><Typography variant='h6' sx={{flexGrow:1}}>SHIPPING LABEL MANAGEMENT</Typography>
            {logged&&<IconButton color='inherit' onClick={()=>setLogoutOpen(true)} aria-label='Log out'><LogoutIcon/></IconButton>}</Toolbar></AppBar>
        <Confirmation open={logoutOpen} onClose={()=>setLogoutOpen(false)} onConfirm={logout} title='Log Out' msg='Confirm logout from Shipping Label Management'/>
        <Outlet context={{Login:{didLogin:setLogged}}}/>
    </Box>;
}
